import * as Yup from 'yup';

export const CpanelSchema = Yup.object().shape({
  aRecord: Yup.string()
    .matches(
      '^(?:(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(.(?!$)|$)){4}$',
      'Incorrect IP address!'
    )
    .required('A Record is required!'),

  cnameRecord: Yup.string()
    .matches('^[A-Za-z0-9]*$', 'Incorrect CNAME, only subdomain name is accepted!')
    .required('CNAME Record is required!'),
  email: Yup.string()
    .min(2, 'Too short!')
    .email('Must be a valid email')
    .max(255, 'Too long!')
    .required('Email is required!')
});

export const ResourceSchema = Yup.object().shape({
  domainName: Yup.string().min(2, 'Too short!').max(30, 'Too long!').required('Name is required!'),
  metadata: Yup.string()
    .min(2, 'Too short!')
    .max(200, 'Too long!')
    .required('Metadata is required!'),
  monthlyCost: Yup.number()
    .integer()
    .positive()
    .min(0)
    .max(100000)
    .required('Monthly cost is required!')
    .typeError('Monthly cost should be number!'),
  type: Yup.string().min(2, 'Too short!').max(30, 'Too long!').required('Type is required!')
});

export const DomainSchema = Yup.object().shape({
  domainName: Yup.string()
    .min(2, 'Too short!')
    .max(30, 'Too long!')
    .matches(
      '^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\\.[a-zA-Z]{2,})+$',
      'Domain name format invalid!'
    )
    .required('Domain name is required!')
});

export const ProjectSchema = Yup.object().shape({
  domainName: Yup.string().min(2, 'Too short!').max(30, 'Too long!')
});

export const ProjectEditSchema = Yup.object().shape({
  api_key: Yup.string().min(2, 'Too short!').max(100, 'Too long!').required('API_KEY is required!'),
  domainName: Yup.string().min(2, 'Too short!').max(30, 'Too long!').required('Name is required!'),
  private_api_key: Yup.string().min(2, 'Too short!').max(100, 'Too long!')
});
